export enum IBoosterPropertyType {
    Flat = "flat",
    House = "house",
    ModularHouse = "modular_house",
    FlatInvestment = "flat_investment",
    HouseInvestment = "house_investment"
}
export enum IBoosterPropertyType {
    Flat = "flat",
    House = "house",
    ModularHouse = "modular_house",
    FlatInvestment = "flat_investment",
    HouseInvestment = "house_investment"
}
